import {
  AuthApiClient,
  PostValidateEmailCodeLoginRequest,
  PostValidateEmailCodeLoginResponse,
} from '@melio/platform-api-axios-client';
// eslint-disable-next-line no-restricted-imports
import { useMutation } from 'react-query';

export function useVerificationCode() {
  return useMutation<PostValidateEmailCodeLoginResponse, unknown, PostValidateEmailCodeLoginRequest>(
    async ({ email, partnerName, code }) => {
      const response = await AuthApiClient.postAuthVerificationCode({ email, partnerName, code });
      return response.data;
    }
  );
}
